import { Button, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const buildV2ClientUrl = path => `/v2/#/${String(path).replace(/^\/+/, '')}`;

function OpenInV2Button({ path, disabled = false }) {
	const { t } = useTranslation('common');
	const handleClick = () => {
		window.open(buildV2ClientUrl(path), '_blank', 'noopener,noreferrer');
	};

	return (
		<Button
			className='whitespace-nowrap mx-4'
			variant='contained'
			color='secondary'
			disabled={disabled}
			onClick={handleClick}
			startIcon={<Icon className='hidden sm:flex'>launch</Icon>}
		>
			{t('open_in_v2')}
		</Button>
	);
}

export default OpenInV2Button;
